import { Widget } from '../../../../enums';
import { InternalMessageType } from '../../enums';
import { InternalMessagePayloadValidator } from '../../types';
import { InternalResizePayload } from './types';

export const internalResizePayloadValidator: InternalMessagePayloadValidator<
  InternalMessageType.Resize
> = (payload: unknown): payload is InternalResizePayload => {
  const filtersValidator = (filters: unknown) => {
    return (
      !!filters &&
      typeof filters === 'object' &&
      'widgetId' in filters &&
      typeof filters.widgetId === 'string' &&
      'widgetType' in filters &&
      Object.values(Widget).includes(filters.widgetType as Widget)
    );
  };

  return (
    !!payload &&
    typeof payload === 'object' &&
    'filters' in payload &&
    filtersValidator(payload.filters) &&
    'height' in payload &&
    typeof payload.height === 'string'
  );
};
